import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PhoneIcon() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    _jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      children: [/*#__PURE__*/_jsx("g", {
        clipPath: "url(#clip0_7168_65350)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M28.01 23.38C26.78 23.38 25.59 23.18 24.48 22.82C24.13 22.7 23.74 22.79 23.47 23.06L21.9 25.03C19.07 23.68 16.42 21.13 15.01 18.2L16.96 16.54C17.23 16.26 17.31 15.87 17.2 15.52C16.83 14.41 16.64 13.22 16.64 11.99C16.64 11.45 16.19 11 15.65 11H12.19C11.65 11 11 11.24 11 11.99C11 21.28 18.73 29 28.01 29C28.72 29 29 28.37 29 27.82V24.37C29 23.83 28.55 23.38 28.01 23.38Z",
          fill: "#707A95"
        })
      }), /*#__PURE__*/_jsx("defs", {
        children: /*#__PURE__*/_jsx("clipPath", {
          id: "clip0_7168_65350",
          children: /*#__PURE__*/_jsx("rect", {
            width: "40",
            height: "40",
            rx: "20",
            fill: "white"
          })
        })
      })]
    })
  );
}